import React, { Component } from "react";
import * as XLSX from 'xlsx';

//Import Breadcrumb
import { Row, Col, Card, CardBody, CardTitle, Button, FormGroup, Label } from "reactstrap"
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";
import "../Masters/datatables.scss"
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

class LedgerReport extends Component {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const fromDate = new Date(currentYear, 3, 1); // April 1st of current year
    const toDate = new Date(currentYear + 1, 2, 31); // March 31st of next year

    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      page: 1,
      sizePerPage: 10,
      productData: [],
      selectedLedger: null,
      ledgerOptions: [],
      fromDate: fromDate,
      toDate: toDate
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Ledger";
    this.modalTitle = "Company Details";
    this.rtPage_Add = "AddLedger";
    this.rtPage_Edit = "EditLedger";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/LedgerMaster";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.handleLedgerChange = this.handleLedgerChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
    this.printReport = this.printReport.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    Fn_FillListData(this.obj, "Fillarray", this.API_URL + "/Id/0");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.Fillarray !== this.state.Fillarray) {
      const options = this.state.Fillarray.map(item => ({
        value: item.Id,
        label: item.Name
      }));

      console.log(options);
      this.setState({ ledgerOptions: options });
    }
  }

  handleLedgerChange(selectedOption) {
    this.setState({ selectedLedger: selectedOption });
  }

  handleFromDateChange(date) {
    this.setState({ fromDate: date });
  }

  handleToDateChange(date) {
    this.setState({ toDate: date });
  }

  handleSubmit = () => {
    const { selectedLedger, fromDate, toDate } = this.state;
    console.log('Selected Values:', {
      ledger: selectedLedger,
      fromDate: fromDate,
      toDate: toDate
    });

    // Format dates for SQL Server (YYYY-MM-DD)
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    let vformData = new FormData();
    vformData.append("Id", selectedLedger.value);
    vformData.append("FromDate", formatDate(fromDate));
    vformData.append("ToDate", formatDate(toDate));
    Fn_GetReport(this.obj, {  arguList: {id: 0, formData: vformData } }, "GetLedgerStatement/0/token", "gridData", true );
  }

  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(Id) {
    this.props.history.push(`${this.rtPage_Edit}/${Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }
  
  exportToExcel = () => {
    if (this.state.gridData && this.state.gridData.length > 0) {
      // Prepare headers
      const headers = [
        'Ledger Name',
        'Entry Date',
        'Description',
        'Debit',
        'Credit',
        'Balance'
      ];

      // Prepare data
      const data = this.state.gridData.map(item => [
        item.LedgerName,
        item.EntryDate,
        item.Description,
        item.Debit,
        item.Credit,
        item.Balance
      ]);

      // Combine headers and data
      const excelData = [headers, ...data];

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(excelData);

      // Set column widths
      const wscols = [
        { wch: 30 }, // Ledger Name
        { wch: 15 }, // Entry Date
        { wch: 40 }, // Description
        { wch: 15 }, // Debit
        { wch: 15 }, // Credit
        { wch: 15 }  // Balance
      ];
      ws['!cols'] = wscols;

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Ledger Report');

      // Save file
      XLSX.writeFile(wb, 'LedgerReport.xlsx');
    }
  }

  printReport = () => {
    if (this.state.gridData && this.state.gridData.length > 0) {
      const printWindow = window.open('', '_blank');
      const obj = JSON.parse( sessionStorage.getItem('authUser'));
      
      // Calculate totals
      const totalDebit = this.state.gridData.reduce((sum, item) => sum + (parseFloat(item.Debit) || 0), 0);
      const totalCredit = this.state.gridData.reduce((sum, item) => sum + (parseFloat(item.Credit) || 0), 0);
      // Get the last item's balance
      const lastBalance = this.state.gridData.length > 0 ? this.state.gridData[this.state.gridData.length - 1].Balance : 0;

      // Format date to dd-mm-yyyy
      const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      // Format number with 2 decimal places, show empty string for zero
      const formatNumber = (num) => {
        const value = parseFloat(num);
        return value === 0 ? '' : value.toFixed(2);
      };

      // Create the print content
      const printContent = `
        <html>
          <head>
            <title>Ledger Report</title>
            <style>
              body { font-family: Arial, sans-serif; font-size: 11px; }
              table { width: 100%; border-collapse: collapse; margin: 20px 0; }
              th, td { border: 1px solid #ddd; padding: 6px 4px; text-align: left; font-size: 10px; white-space: nowrap; }
              th { background-color: #f5f5f5; font-size: 10px; }
              .header { text-align: center; margin-bottom: 20px; }
              .date-range { margin-bottom: 20px; }
              .amount { text-align: right; }
              .total-row { font-weight: bold; background-color: #f8f9fa; }
              @media print {
                .no-print { display: none; }
                body { font-size: 11px; padding: 0 10mm; }
                th, td { font-size: 10px; padding: 4px; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>Ledger Report</h2>
              <div class="date-range">
                   <strong>${obj.FirmName}</strong><br>
                From: ${formatDate(this.state.fromDate)} To: ${formatDate(this.state.toDate)}
                ${this.state.selectedLedger ? `<br>Ledger: ${this.state.selectedLedger.label}` : ''}
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Entry Date</th>
                  <th>Description</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                ${this.state.gridData.map(item => `
                  <tr>
                    <td>${item.EntryDate ? item.EntryDate : ''}</td>
                    <td>${item.Description}</td>
                    <td class="amount">${formatNumber(item.Debit)}</td>
                    <td class="amount">${formatNumber(item.Credit)}</td>
                    <td class="amount">${formatNumber(item.Balance)}</td>
                  </tr>
                `).join('')}
                <tr class="total-row">
                  <td colspan="2">Total</td>
                  <td class="amount">${formatNumber(totalDebit)}</td>
                  <td class="amount">${formatNumber(totalCredit)}</td>
                  <td class="amount">${formatNumber(lastBalance)}</td>
                </tr>
              </tbody>
            </table>
            <div class="no-print" style="text-align: center; margin-top: 20px;">
              <button onclick="window.print()">Print Report</button>
            </div>
          </body>
        </html>
      `;

      printWindow.document.write(printContent);
      printWindow.document.close();
    }
  }

  render() {
    const columns = [{
      dataField: 'LedgerName',
      text: 'LedgerName',
      sort: true,
      searchable: true
    }, {
      dataField: 'EntryDate',
      text: 'EntryDate',
      sort: true,
      searchable: true
    }, {
      dataField: 'Description',
      text: 'Description',
      sort: true,
      searchable: true
    }, {
      dataField: 'Debit',
      text: 'Debit',
      sort: true,
      searchable: true,
      formatter: (cell) => parseFloat(cell) === 0 ? '' : parseFloat(cell).toFixed(2)
    }, {
      dataField: 'Credit',
      text: 'Credit',
      sort: true,
      searchable: true,
      formatter: (cell) => parseFloat(cell) === 0 ? '' : parseFloat(cell).toFixed(2)
    }, {
      dataField: 'Balance',
      text: 'Balance',
      sort: true,
      searchable: true
    }];

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.gridData,
      custom: true,
    }
    const selectRow = {
      mode: 'checkbox'
    }
    const { SearchBar } = Search;

    return (
      <div className="page-content">
        <Row className="mb-3">
          <Col md={3}>
            <FormGroup>
              <Label>Select Ledger</Label>
              <Select
                value={this.state.selectedLedger}
                onChange={this.handleLedgerChange}
                options={this.state.ledgerOptions}
                isSearchable={true}
                placeholder="Select Ledger..."
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>From Date</Label>
              <DatePicker
                selected={this.state.fromDate}
                onChange={this.handleFromDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>To Date</Label>
              <DatePicker
                selected={this.state.toDate}
                onChange={this.handleToDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>&nbsp;</Label>
              <Button 
                color="primary" 
                className="w-100" 
                onClick={this.handleSubmit}
                disabled={!this.state.selectedLedger}
              >
                Submit
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField='id'
          columns={columns}
          data={this.state.gridData}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField='id'
              columns={columns}
              data={this.state.gridData}
              search
              bootstrap4
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row className="mb-2">
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            {...toolkitProps.searchProps}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          {this.state.gridData && this.state.gridData.length > 0 && (
                            <>
                              <Button 
                                color="success" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.exportToExcel}
                              >
                                <i className="mdi mdi-file-excel mr-1"></i> Export to Excel
                              </Button>
                              <Button 
                                color="info" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.printReport}
                              >
                                <i className="mdi mdi-printer mr-1"></i> Print Report
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap"
                          }
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone
                          {...paginationProps}
                        />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone
                          {...paginationProps}
                        />
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </div>
    );
  }
}
export default compose(container)(LedgerReport);